export const MIN_USER_AGE = 18;
